import FeatShield from "../assets/featureSheild.png";
import FeatMagnifier from "../assets/featuremagnifier.png";
import FeatNutrients from "../assets/featureneutriant.png";
import FeatBooster from "../assets/featurebooster.png";
import FeatGurantee from "../assets/featuregurantee.png";
import FeatBreathing from "../assets/featurebreathing.png";
import Img1 from "../assets/image 22.png";
import Img2 from "../assets/magnesium-bhb.jpg.png";
import Img3 from "../assets/sodium-bhb.jpg.png";
import Bottle2 from "../assets/respoClearBottle.png";
import Bottle3 from "../assets/updated-3.png";
import Bottle6 from "../assets/respo-fe-6.png";
import Fda from "../assets/Figure → fda.png.png";
import Gmo from "../assets/Figure → gmo.png.png";
import Gmp from "../assets/Figure → gmp.png.png";
import Nat from "../assets/Figure → nat.png.png";
import Usa from "../assets/Figure → usa.png.png";
import test1 from "../assets/test1 (1).png";
import test2 from "../assets/test1 (2).png";
import test3 from "../assets/test1 (3).png";
import bonus1 from "../assets/img-lung-support-group.png";
import bonus2 from "../assets/Group 35.png";
// import User1 from "../assets/user1Review.png"
// import User2 from "../assets/user2Review.png"
// import User3 from "../assets/user3Review.png"
// import User4 from "../assets/user4Review.png"
import User1 from "../assets/testm1.jpeg";
import User2 from "../assets/testm2.JPG";
import User3 from "../assets/testm3.jpg";
import User4 from "../assets/testm4.jpg";
import ProductLabel from "../assets/respo-product-label-2.png";

export const features = [
  {
    icon: FeatShield,
    title: "Enhanced Respiratory Function",
    description:
      "Experience fast, natural support for optimal lung function and easy breathing.",
  },
  {
    icon: FeatMagnifier,
    title: "Clear Airways Solutions",
    description: "Rapid and effective support for unobstructed airways.",
  },
  {
    icon: FeatNutrients,
    title: "Natural Ingredients",
    description: "Best-in-class bioactive ingredients, scientifically proven.",
  },
  {
    icon: FeatBooster,
    title: "Immune Boosting",
    description:
      "Strengthen your body's defenses and protect against allergens and irritants.",
  },
  {
    icon: FeatGurantee,
    title: "Satisfaction Guaranteed",
    description:
      "Risk-free trial with 180-day money-back guarantee for your peace of mind.",
  },
  {
    icon: FeatBreathing,
    title: "Effortless Breathing",
    description: "Breathe freely with Respoclear's proven formula. ",
  },
];

export const ScienceBackdata = [
  {
    id: 1,
    imageSrc: Img2,
    alt: "Groundbreaking Research",
    title: "Groundbreaking Research",
    description:
      "Backed by extensive clinical studies and scientific research.",
  },
  {
    id: 2,
    imageSrc: Img1,
    alt: "Clinically-Proven Ingredients",
    title: "Clinically-Proven Ingredients",
    description: "Carefully selected ingredients for maximum effectiveness.",
  },
  {
    id: 3,
    imageSrc: Img3,
    alt: "Advanced Respiratory Support",
    title: "Advanced Respiratory Support",
    description:
      "Designed to promote optimal lung function and overall respiratory wellness.",
  },
];

export const plans = [
  {
    img: Bottle2,
    title: "2 Bottles",
    subtitle: "60 Day Supply",
    leastpopular: true,
    price: 79,
    buttonText: "BUY NOW",
    buttonColor: "bg-yellow-400",
    url: "https://scalerespo.pay.clickbank.net/?cbitems=1&cbfid=58855&template=respo02&v=y",
    popular: false,
    shipping: "$9.99",
    discount: " You Save $200",
    gurantee: " 180 DAYS GUARANTEE",
    buttonTextType: "Basic Offer",
    old_price: "358",
    new_price: "158",
  },
  {
    img: Bottle6,
    title: "6 Bottles",
    subtitle: "180 Day Supply",
    price: 49,
    buttonText: "BUY NOW",
    buttonColor: "bg-orange-500",
    url: "https://scalerespo.pay.clickbank.net/?cbitems=2&cbfid=58855&template=respo06&v=y",
    leastpopular: false,
    popular: true,
    shipping: "free",
    discount: " YOU SAVE $780",
    biggestdisc: " BIGGEST DISCOUNT",
    gurantee: "180 DAYS GUARANTEE",
    freedelivery: "Fast & Free Delivery",
    bonuses: "2 bonuses",
    buttonTextType: "Best Offer",
    old_price: "1074",
    new_price: "294",
  },
  {
    img: Bottle3,
    title: "3 Bottles",
    subtitle: "90 Day Supply",
    price: 69,
    features: ["180-DAY SUPPLY"],
    buttonText: "BUY NOW",
    url: "https://scalerespo.pay.clickbank.net/?cbitems=3&cbfid=58855&template=respo03&v=y",
    leastpopular: false,
    buttonColor: "bg-yellow-400",
    popular: false,
    shipping: "free",
    discount: "  YOU SAVE $330",
    freedelivery: "Fast & Free Delivery",
    gurantee: "180 DAYS GUARANTEE",
    buttonTextType: "Good Offer",
    old_price: "537",
    new_price: "207",
  },
];

export const faqsData = [
  {
    question: "Is Respoclear right for me?",
    answer:
      "Every person is different, but Respoclear® is remarkably effective for nearly everyone who's tried it. It contains well-studied ingredients with tons of evidence showing their efficacy. Plus, it supports lung health and promotes healthy mucus function. But if for any reason you're not satisfied with Respoclear, remember that you can always return it and receive 100% of your investment back.",
  },
  {
    question: "Is Respoclear safe?",
    answer:
      "Respoclear is a natural proprietary formula manufactured in the USA at our FDA-registered and GMP-certified facility using state-of-the-art, precision-engineered machinery and under the strictest and most sterile standards. Each ingredient is 100% natural, soy-free, dairy-free, non-GMO, and undergoes additional third-party inspections and quality control to ensure high purity and potency. As always, we advise you to show a bottle of this to your doctor before you take it, just to be safe.",
  },
  {
    question: "How long will it take to see results?",
    answer:
      "Some customers have seen results immediately, while for most it will take 3-6 months to get the best results. Each case is different, and a number of factors can influence the amount of time it'll take to see improvement. We strongly recommend taking Respoclear® for at least 3-6 months for your best chance at success. Therefore, we highly recommend the 6-bottle and 3-bottle options of Respoclear for best results. We also understand that despite the great success rate with our formula, it won't work for everyone. That's why we offer a 180-day guarantee on your most recent order. If Respoclear® doesn't work for you, we give you 180 days to request a refund (minus shipping & handling) on your most recent order. Make the smart decision and get the heavily discounted 6-bottle package, which comes with the 1 bonus eBook absolutely free along with access to our lung support community.",
  },
  {
    question: "What is the best way to take Respoclear?",
    answer:
      "Take 2 capsules daily. For best results, take with 6-8 oz of water after a meal or as directed by a healthcare professional.",
  },
  {
    question:
      "Is this a one-time payment with no auto-ship, subscription, or hidden charges?",
    answer:
      "Yes, your order today is a one-time payment with no auto-ship, subscriptions, or hidden charges.",
  },
  {
    question: "What if Respoclear® doesn’t work for me?",
    answer:
      "Every single bottle of Respoclear® comes with our personal 180-day 100% money-back guarantee. If for any reason you're unsatisfied with your results, just return the bottles for a full, no-questions-asked refund.",
  },
  {
    question: "What do I do now?",
    answer:
      "This is the fun part. Click on one of the packages below. Enter your order details on our secure checkout page. After you've finished, we'll get your Respoclear® shipped out to you straight away. Order 6 bottles and get the a free eBook along with access to lung support community.",
  },
  {
    question: "Where can I find the Respoclear product label?",
    answer: "You can find the full Respoclear product label below:",
    img: ProductLabel,
  },
];

export const VSLClinicalStudiesData = [
  "https://phys.org/news/2007-05-radiation-eating-fungi.html#google_vignette",
  "https://www.ncbi.nlm.nih.gov/pubmed/9932596",
  "https://www.ncbi.nlm.nih.gov/pubmed/25339490",
  "https://fjmd.com/detox-from-mold-glutathione-mother-of-all-antioxidants/",
  "https://www.ncbi.nlm.nih.gov/pubmed/27117852",
  "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7892733/#Sec20title",
  "https://www.sciencedirect.com/science/article/pii/S1756464614002400",
  "https://pubmed.ncbi.nlm.nih.gov/28198157/",
  "https://www.ncbi.nlm.nih.gov/pubmed/27207147",
  "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3706886/",
  "https://pubmed.ncbi.nlm.nih.gov/12452574/",
  "https://jamanetwork.com/journals/jamaotolaryngology/fullarticle/509953",
  "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4443571/",
  "https://www.ncbi.nlm.nih.gov/labs/pmc/articles/PMC7892733/",
  "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4744393/",
  "https://fdc.nal.usda.gov/fdc-app.html#/food-details/171727/nutrients",
  "https://pubmed.ncbi.nlm.nih.gov/22129334/",
  "https://www.ncbi.nlm.nih.gov/pubmed/18356331",
  "https://www.webmd.com/diet/health-benefits-thyme#:~:text=Thyme%20may%20help%20with%3A,well%20as%20in%20the%20kitchen",
  "https://www.medicalnewstoday.com/what_is_bromelain_good_for/article.htm#:~:text=Chronic%20sinusitis%20(chronic%20rhinosinusitis),n%20as%20a%20substitute%20for%20conventional%20chemotherapy",
];

export const referencesData = [
  "https://phys.org/news/2007-05-radiation-eating-fungi.html#google_vignette",
  "https://pubmed.ncbi.nlm.nih.gov/12452574/",
  "https://www.ncbi.nlm.nih.gov/pubmed/9932596",
  "https://jamanetwork.com/journals/jamaotolaryngology/fullarticle/509953",
  "https://www.ncbi.nlm.nih.gov/pubmed/25339490",
  "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4443571/",
  "https://jjmd.com/detox-from-mold-glutathione-mother-of-all-antioxidants/",
  "https://www.ncbi.nlm.nih.gov/labs/pmc/articles/PMC7892733/",
  "https://www.ncbi.nlm.nih.gov/pubmed/27117852",
  "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4744393/",
  "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7892733/#Sec20title",
  "https://fdc.nal.usda.gov/fdc-app.html#/food-details/171727/nutrients",
  "https://www.sciencedirect.com/science/article/pii/S1756464614002400",
  "https://pubmed.ncbi.nlm.nih.gov/22129334/",
  "https://pubmed.ncbi.nlm.nih.gov/28198157/",
  "https://www.ncbi.nlm.nih.gov/pubmed/18356331",
  "https://www.ncbi.nlm.nih.gov/pubmed/27207147",
  "https://www.webmd.com/diet/health-benefits-thyme#:~:text=Thyme%20may%20help%20with%3A,well%20as%20in%20the%20kitchen",
  "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3706886/",
  "https://www.medicalnewstoday.com/what_is_bromelain_good_for/article.htm#:~:text=Chronic%20sinusitis%20(chronic%20rhinosinusitis),n%20as%20substitute%20for%20conventional%20chemotherapy",
];

export const icons = [
  {
    src: Gmp,
    alt: "GMP Certified",
  },
  {
    src: Fda,
    alt: "FDA Approved",
  },
  {
    src: Gmo,
    alt: "GMO Free",
  },
  {
    src: Nat,
    alt: "Natural Ingredients",
  },
  {
    src: Usa,
    alt: "USA Manufactured",
  },
];

export const VslPricingData = [
  {
    product: "https://cdn.blackincae.com/respoclear/IhP-2-bottle-fe.png",
    title: "2 Bottles",
    subtitle: "60 Day Supply",
    pricePerBottle: 79,
    url: "https://scalerespo.pay.clickbank.net/?cbitems=1&cbfid=58855&template=respo02&v=y",
    buttonlink: "#",
    leastpopular: true,
    popular: false,
    // youSave: 'You Save $200!',
    originalPrice: "358",
    discountedPrice: "158",
    bestValue: false,
    id: 1,
    shippingfee: "PLUS $9.95 SHIPPING",
  },
  {
    product: "https://cdn.blackincae.com/respoclear/Bc0-6-bottles-fe.png",
    title: "6 Bottles",
    subtitle: " 180 Day Supply",
    pricePerBottle: 49,
    url: "https://scalerespo.pay.clickbank.net/?cbitems=2&cbfid=58855&template=respo06&v=y",
    buttonlink: "#",
    leastpopular: false,
    popular: true,
    discount: "BIGGEST DISCOUNT",
    freeshipping: "FAST & FREE SHIPPING",
    bonuses: "2 BONUSES",
    originalPrice: "1,074 ",
    discountedPrice: "294",
    bestValue: true,
    id: 2,
    shippingfee: "",
  },
  {
    product: "https://cdn.blackincae.com/respoclear/4jI-3-bottles-u1-fe.png",
    title: "3 Bottles",
    subtitle: "90 Day Supply",
    pricePerBottle: 69,
    url: "https://scalerespo.pay.clickbank.net/?cbitems=3&cbfid=58855&template=respo03&v=y",
    buttonlink: "#",
    leastpopular: false,
    popular: false,
    freeshipping: "FAST & FREE SHIPPING",
    originalPrice: "537 ",
    discountedPrice: "207",
    bestValue: false,
    shippingfee: "",
    id: 3,
  },
];
export const appendVidToUrls = (data, vid) => {
  return data.map((item) => {
    const separator = item.url.includes("?") ? "&" : "?";
    return {
      ...item,
      url: `${item.url}${separator}tid=${vid}`,
    };
  });
};

export const cardsData = [
  {
    id: 1,
    imgSrc: bonus1,
    title: "BONUS #1 Lung Support Community",
    rrp: "199",
    todayPrice: " FREE",
    description: `
Join the Lung Support Community and connect with a group dedicated to respiratory health and lung comfort! Explore expert-approved tips and natural remedies to support lung function, ease breathing difficulties, and promote clear airways. This community offers practical and effective lung-care methods while helping you understand their benefits, empowering you to take control of your respiratory health with confidence.        `,
    bgColor: "#2D4667",
  },
  {
    id: 2,
    imgSrc: bonus2,
    title: "Bonus #2 Healthy Lung Lifestyle",
    rrp: "49",
    todayPrice: "Free",
    description: `
This eBook is packed with nutrient-rich recipes and proven dietary strategies designed to support lung health, reduce inflammation, and clear stubborn mucus. Learn how superfoods like turmeric, ginger, and fresh greens can help strengthen your lungs and improve breathing, while avoiding common respiratory triggers like dairy and refined sugars. With easy-to-follow meal plans and natural remedies, this guide makes lung-friendly living simple and sustainable. Start your journey to clearer airways and healthier lungs today!        `,
    bgColor: "#2D4667",
    note: "This is an eBook digital download, not a physical book.",
  },
];

export const VslTestimonialImages = [
  {
    id: "bottom-testi1",
    src: "https://cdn.blackincae.com/respoclear-resize/nG8-img_7599.jpeg",
    alt: "User1",
  },
  {
    id: "bottom-testi2",
    src: "https://cdn.blackincae.com/respoclear-resize/eO6-img_6234.jpg",
    alt: "User2",
  },
  {
    id: "bottom-testi3",
    src: "https://cdn.blackincae.com/respoclear-resize/hEp-img_2298.jpg",
    alt: "User3",
  },
  {
    id: "bottom-testi4",
    src: "https://cdn.blackincae.com/respoclear-resize/Qch-img_1838.jpeg",
    alt: "User4",
  },
];

export const VslTestimonials = [
  {
    id: 1,
    img: test1,
    text: "I’ve tried countless sinus sprays and treatments, but nothing works like Respoclear. It provides fast and lasting relief without the harsh side effects of other products. Plus, I love that it supports my lung health and promotes healthy mucus function. I can finally breathe without feeling stuffed up all day. Highly recommended for anyone with sinus issues!",
    name: "Tom L.",
  },
  {
    id: 2,
    img: test2,
    text: "I’ve struggled with sinus pressure for years, especially during allergy season. After trying Respoclear,I felt an instant difference. It quickly cleared up my congestion, supported my lung health, and allowed me to breathe freely again. It's now my go-to solution for sinus discomfort!",
    name: "Sarah J.",
  },
  {
    id: 3,
    img: test3,
    text: "I love that Respoclear is made with natural ingredients. It's so much safer and more effective than other over-the-counter sinus products I've tried. Not only does it clear my sinuses in just a few minutes, but it also supports healthy mucus function and overall lung health. It's a must-have in my medicine cabinet!",
    name: "Mark D.",
  },
];

export const LOADER_STATUS = {
  NA: -1,
  PAUSE: 0,
  PLAY: 1,
};

export const LOADER_STATUS_PM = {
  NA: -1,
  PAUSE: 0,
  PLAY: 1,
};
